import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Edit video',
  back: 'Back',
  tipHeader: 'Instructions',
  tip1: 'The <strong>"Add video"</strong> button lets you pick media from your library or generate AI images and clips.',
  tip2: '<strong>Edit the script</strong> to change the audio connected your chosen segment. You can adjust the content, language and narration settings.',
  tip3: '<strong>Regenerate</strong> reprocesses only the selected clip based on its linked page.',
  tip4: '<strong>Mute audio</strong> hides the sound for that segment.',
  editVideoOptions_EditScript: 'Edit script',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Regenerate',
  editVideoOptions_ChangeMedia: 'Replace with Storyblocks',
  editVideoOptions_ChangeMediaLibrary: 'Replace with Media library',
  editVideoOptions_Delete: 'Delete',
  editVideoOptions_EditNarration: 'Edit narration',
  editVideoOptions_ConfirmDelete: 'Are you sure you want to delete this clip?',
  editNarrationModalTitle: 'Edit narration',
  editNarrationModalSave: 'Save',
  editNarrationSuccess: 'Narration updated successfully',
  emptyChunkPreview: 'No clip selected for preview',
  stateRegenerating: 'Regenerating video',
  stateChangingMedia: 'Changing media',
  stateMutingAudio: 'Muting audio',
  stateReplacingWithLibrary: 'Replacing with Media library',
  stateChangingNarration: 'Updating narration',
};

const welsh = {
  title: 'Golygu Ffynhonnell y Fideo',
  back: 'Yn ôl',
  tipHeader: 'Cyfarwyddiadau',
  tip1: 'Mae\'r botwm <strong>"Ychwanegu fideo"</strong> yn eich galluogi i ddewis cyfryngau o\'ch llyfrgell neu gynhyrchu delweddau a clipiau AI.',
  tip2: "<strong>Golygu'r sgript</strong> i newid y sain sy'n gysylltiedig â'r segment a ddewiswyd. Gallwch addasu'r cynnwys, y iaith a'r gosodiadau darllen.",
  tip3: '<strong>Ailgynhyrchu</strong> yn ailbrosesu dim ond y clip a ddewiswyd yn seiliedig ar ei dudalen gysylltiedig.',
  tip4: "<strong>Mute audio</strong> yn cuddio'r sain ar gyfer y segment hwnnw.",
  editVideoOptions_EditScript: 'Golygu sgript',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Ailgynhyrchu',
  editVideoOptions_ChangeMedia: 'Newid cyfryngau',
  editVideoOptions_ChangeMediaLibrary: 'Newid cyfryngau',
  editVideoOptions_Delete: 'Dileu',
  editVideoOptions_EditNarration: 'Golygu adroddiad',
  editVideoOptions_ConfirmDelete: "Ydych chi wir eisiau dileu'r clip hwn?",
  editNarrationModalTitle: 'Golygu adroddiad',
  editNarrationModalSave: 'Cadw',
  editNarrationSuccess: "Adroddiad wedi'i ddiweddaru'n llwyddiannus",
  emptyChunkPreview: "Dim darn wedi'i ddewis ar gyfer rhagolwg",
  stateRegenerating: 'Ail-greu fideo',
  stateChangingMedia: 'Newid cyfryngau',
  stateMutingAudio: 'Tawelu sain',
  stateReplacingWithLibrary: 'Yn disodli gyda chyfrwng y llyfrgell',
  stateChangingNarration: 'Diweddaru adroddiad',
};

export const VideoEditorText: any = getLocalizationBasedOnLang(english, welsh);
